/**
 * Layout constants for CalendarWeekView.
 * Hour blocks: 150px wide, 80px tall. Day range: 8am–8pm.
 */
export const CELL_WIDTH = 150;
export const HOUR_HEIGHT = 80;
export const START_HOUR = 8;
export const END_HOUR = 20;
export const HOURS_COUNT = END_HOUR - START_HOUR;
export const TIME_LABEL_WIDTH = 48;
